<input
  class="text-input"
  type="text"
  [class.form-error-border]="error"
  [attr.id]="controlId"
  [maskito]="maskOptions"
  [value]="value"
  autocomplete="off"
  [disabled]="disabled"
  [readOnly]="readonly"
  [placeholder]="placeholder"
  (input)="handleInput($event)" />
